import { ProjectMilestoneStatus } from "@/enums";
import { flattenProjectScheduleMilestones } from "./flattenProjectScheduleMilestones";
/**
 * @param project Project to look for other milestones in invalid status
 */
export const PassesProjectCompleteRequirements = (project) => {
  const projectMilestones = flattenProjectScheduleMilestones(project);
  const projectCompleteMilestone =
    projectMilestones?.find(
      ({ shouldCompleteProject }) => shouldCompleteProject === true
    ) ?? false;

  //if we can't find a milestone with ShouldCompleteProject we're going to default to true
  if (!projectCompleteMilestone) return true;

  const milestonesInInvalidStatus = projectMilestones.filter(
    ({ id, status }) =>
      status === ProjectMilestoneStatus.InApproval &&
      id !== projectCompleteMilestone.id
  );

  return !milestonesInInvalidStatus?.length;
};
